import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import CaseReviewDetails from "../components/CaseReviewDetails";
import CaseReviewNavbar from "../components/CaseReviewNavbar";
import * as XLSX from "xlsx"; // at the top
import FooterSection from "../components/FooterSection";
import DashboardHeader from "../components/DashboardHeader";

const mockData = {
  doctors: {
    title: "Why use this?",
    features: [
      { icon: "./doctor/images/layer_177.png", text: "Real-time stigma and tone feedback" },
      { icon: "./doctor/images/layer_178.png", text: "Tailored for clinical consults" },
    ],
    cases: [
      "Gestational Diabetes – First Visit",
      "Type 2 Diabetes - Newly Diagnosed",
      "Obesity with Hypertension",
      "Gestational Diabetes – First Visit",
      "Type 2 Diabetes - Newly Diagnosed",
      "Obesity with Hypertension",
    ],
  },
  smu_student_cases: {
    title: "Get your communication quotient via full discourse analysis",
    features: [
      { icon: "./student/images/layer_193.png", text: "Empathy + Stigma scores" },
      { icon: "./student/images/layer_194.png", text: "Safe space to practice & reflect" },
    ],
    cases: [
      "Adolescent PCOS - Sensitive Language",
      "Acute Diarrhea - Empathy Check",
      "Insulin Initiation - Handling Fear",
      "Adolescent PCOS - Sensitive Language",
      "Acute Diarrhea - Empathy Check",
      "Insulin Initiation - Handling Fear",
    ],
  },
  staff: {
    title: "Counseling with Care",
    features: [
      { icon: "./staff/images/layer_195.png", text: "Applicable for nutritionists, educators, etc." },
      { icon: "./staff/images/layer_196.png", text: "Focused on communication quality" },
    ],
    cases: [
      "Group Counseling on Lifestyle",
      "Diet Advice for GDM",
      "Discussing Weight Without Stigma",
      "Group Counseling on Lifestyle",
      "Diet Advice for GDM",
      "Discussing Weight Without Stigma",
    ],
  },
};

function RoleSlider({ name }) {
  const generatePatientId = () => `PAT-${Date.now()}`;

  const [id, setId] = useState(generatePatientId());
  const [patientname, setName] = useState("");
  const [age, setAge] = useState("");
  const [culturalBackground, setCulturalBackground] = useState("");
  const [positiveWords, setPositiveWords] = useState([]);
  const [doctorCard, setDoctorCard] = useState([]);
  const [medicalCard, setMedicalCard] = useState([]);
  const [staffCard, setStaffCard] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [language, setLanguage] = useState("original");
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const API_BASE_URL = process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_API_BASE_URL
    : process.env.REACT_APP_DEV_API_BASE_URL;
  const navigate = useNavigate();

  const handleCardClick = (index) => setSelectedIndex(index);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const getCardDataByRole = () => {
    switch (role) {
      case "smu_student_cases":
        return medicalCard;
      case "staff":
        return staffCard;
      default:
        return doctorCard;
    }
  };

  const casereview = () => {
    if (selectedIndex === null) {
      alert("Please select a patient case first.");
      return;
    }
    const selectedPatient = filteredCardData[selectedIndex];
    navigate("/consultation", { state: { patient: selectedPatient } });
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const [role, setRole] = useState("smu_student_cases");
  const [scrollIndex, setScrollIndex] = useState(0);

  const roleData = mockData[role];
  const visibleCases = roleData.cases.slice(scrollIndex, scrollIndex + 3);
  const currentCardData = getCardDataByRole();

  // Filter by category if selected
  const filteredCardData = selectedCategory
    ? currentCardData.filter(item => item.Category === selectedCategory)
    : currentCardData;

  const nextSlide = () => {
    if (scrollIndex + 3 < filteredCardData.length) setScrollIndex(scrollIndex + 1);
  };

  const prevSlide = () => {
    if (scrollIndex > 0) setScrollIndex(scrollIndex - 1);
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setScrollIndex(0);
    setSelectedIndex(null);
  };

  const getTabLabel = (key) => {
    switch (key) {
      case "smu_student_cases": return "Medical Students";
      case "staff": return "Allied Staff";
      default: return "Doctors";
    }
  };

  useEffect(() => {
    const fetchMedicalData = async () => {
      try {
        //        const res = await fetch(`${process.env.PUBLIC_URL}/data/medical_cases.json`);
        //        const res = await fetch(`${process.env.PUBLIC_URL}/data/3_medical_cases.json`);
        //          const res = await fetch(`${process.env.PUBLIC_URL}/data/clinician_medical_student.json`);
        // const res = await fetch(`${process.env.PUBLIC_URL}/data/smu_student.json`);

        const res = await fetch(`${process.env.PUBLIC_URL}/data/ims_smu_student.json`);

        
        const data = await res.json();

        setDoctorCard(data.smu_student_cases || []);
        setMedicalCard(data.smu_student_cases || []);
        setStaffCard(data.smu_student_cases || []);

        // Extract unique categories from all data
        const allData = [...(data.smu_student_cases || [])];
        const uniqueCategories = [...new Set(allData.map(item => item.Category).filter(Boolean))];
        setCategories(uniqueCategories);
      } catch (err) {
        console.error("Failed to load medical cases:", err);
      }
    };

    fetchMedicalData();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">



      {/* Navbar */}
      <div className="z-10">
        <CaseReviewNavbar name={name} />
      </div>

      {/* Main Content */}
      <div className="relative isolate">

        {/* =========================
        TOP CONTENT
    ========================== */}


        {/* =================================================
                    HEADER
                ================================================== */}
        <DashboardHeader

        />

        <div className="max-w-7xl mx-auto px-4 pt-8">

          {/* =========================
          Filters
      ========================== */}
          <div className="bg-white rounded-3xl shadow-md p-6">

            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">

              {/* Specialty */}
              <div className="w-full lg:w-80">

                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Select Specialty
                </label>

                <select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  className="w-full h-12 rounded-xl border border-gray-300 px-4 focus:ring-2 focus:ring-[#1D3A73]"
                >
                  <option value="">
                    All Specialties
                  </option>

                  {categories.map((category) => (
                    <option key={category}>
                      {category}
                    </option>
                  ))}
                </select>

              </div>

              {/* Tabs */}
              <div className="flex flex-wrap gap-3">

                {Object.keys(mockData).map((r) => {

                  const isDisabled =
                    r === "doctors" || r === "staff";

                  return (
                    <button
                      key={r}
                      disabled={isDisabled}
                      onClick={() => {

                        if (!isDisabled) {
                          setRole(r);
                          setSelectedCategory("");
                          setSelectedIndex(null);
                        }

                      }}
                      className={`
                    px-6 h-11 rounded-full font-semibold transition

                    ${isDisabled
                          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                          : role === r
                            ? "bg-[#1D3A73] text-white"
                            : "border hover:border-[#1D3A73]"
                        }
                  `}
                    >
                      {getTabLabel(r)}
                    </button>
                  );

                })}

              </div>

            </div>

          </div>


          {/* =========================
          HEADING
      ========================== */}
          <div className="mt-12 mb-10 text-center">

            <h2 className="text-4xl font-bold text-[#1D3A73]">
              Choose Your Mock Consultation
            </h2>

            <p className="text-gray-500 mt-3">
              Select one case below to begin your practice consultation.
            </p>

          </div>

        </div>


        {/* =================================================
        CARDS SECTION - FULL WIDTH BLUE BACKGROUND
    ================================================== */}
        <div className="w-full bg-[#1D3A73] py-16">

          {/* Cards Container */}
          <div className="max-w-7xl mx-auto px-6">

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-7">

              {filteredCardData.map((patient, index) => {

                const selected = selectedIndex === index;

                return (

                  <div
                    key={index}
                    onClick={() => handleCardClick(index)}
                    className={`
                  cursor-pointer
                  rounded-3xl
                  border
                  bg-white
                  transition-all
                  duration-300
                  overflow-hidden

                  ${selected
                        ? "border-orange-400 shadow-2xl scale-[1.02]"
                        : "border-gray-200 hover:border-orange-300 hover:shadow-xl"
                      }
                `}
                  >

                    {/* Card Header */}
                    <div
                      className={`
                    h-2
                    ${selected
                          ? "bg-orange-400"
                          : "bg-gray-100"
                        }
                  `}
                    />


                    {/* Card Content */}
                    <div className="p-6 flex flex-col h-full">

                      {/* Badge + Selected */}
                      <div className="flex justify-between items-center mb-5">

                        <span
                          className={`
                        text-xs
                        px-3
                        py-1
                        rounded-full
                        font-semibold

                        ${selected
                              ? "bg-orange-100 text-orange-700"
                              : "bg-blue-50 text-[#1D3A73]"
                            }
                      `}
                        >
                          Mock Case
                        </span>

                        {selected && (
                          <span className="text-green-600 text-xl">
                            ✓
                          </span>
                        )}

                      </div>


                      {/* Case Title */}
                      <h3 className="text-lg font-bold leading-7">
                        {patient["Case Type"]}
                      </h3>


                      {/* Description */}
                      <p className="mt-4 text-sm text-gray-500 flex-grow">
                        Practice this consultation scenario with AI and receive
                        feedback on communication and empathy.
                      </p>


                      {/* Button */}
                      {selected ? (

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            casereview();
                          }}
                          className="
                        mt-6
                        w-full
                        bg-[#F7941D]
                        hover:bg-[#e68310]
                        text-black
                        font-bold
                        py-3
                        rounded-xl
                        transition
                      "
                        >
                          Try a Mock Consultation
                        </button>

                      ) : (

                        <button
                          className="
                        mt-6
                        w-full
                        border
                        border-orange-300
                        text-orange-500
                        py-3
                        rounded-xl
                        hover:bg-orange-50
                        transition
                      "
                        >
                          Select Case
                        </button>

                      )}

                    </div>

                  </div>

                );

              })}

            </div>

          </div>

        </div>


        {/* =========================
        EMPTY STATE
    ========================== */}
        {filteredCardData.length === 0 && (

          <div className="max-w-7xl mx-auto px-4">

            <div className="bg-white rounded-3xl shadow-md mt-12 p-12 text-center">

              <h3 className="text-xl font-semibold text-gray-700">
                No Cases Found
              </h3>

              <p className="text-gray-500 mt-2">
                Try selecting another specialty.
              </p>

            </div>

          </div>

        )}


        {/* =========================
        WANT MORE SECTION
    ========================== */}
        <div className="max-w-7xl mx-auto px-4">

          <div className="text-center mt-16 mb-10">

            <h3 className="text-xl font-bold text-[#1D3A73] mb-2">
              Want more?
            </h3>

            <p className="text-sm mb-6">
              After your first trial, explore the full{" "}
              <span className="text-[#F7941D] font-semibold">
                ConversationAlly
              </span>{" "}
              platform:
            </p>


            <div className="flex justify-center flex-wrap gap-6">

              {[
                "./doctor/images/layer_179.png",
                "./doctor/images/layer_180.png",
                "./doctor/images/layer_181.png",
              ].map((img, i) => (

                <div
                  key={i}
                  className="
                bg-[#1D3A73]
                border
                border-white
                rounded-2xl
                px-6
                py-6
                flex
                flex-row
                items-center
                w-[200px]
                text-white
              "
                >

                  <img
                    src={img}
                    alt="feature icon"
                    className="h-10 mb-2 mr-2"
                  />

                  <p className="text-sm text-center">

                    {i === 0 && "Longitudinal feedback"}

                    {i === 1 && "Multi-language cue libraries"}

                    {i === 2 && "Custom reports for clinics"}

                  </p>

                </div>

              ))}

            </div>

          </div>

        </div>

      </div>


      {/* Footer */}
      <FooterSection />
    </div>
  );
}

export default RoleSlider;